module.exports = __webpack_public_path__ + "static/media/Excel_Icon.2617f053.svg";